import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import ChartIcon from "../../../assets/chart.png";
import "./LivePricesTable.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import * as React from "react";
import { alpha, styled } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

interface LivePricesTableProps {
  label?: string;
  more?: string;
}

interface Currency {
  id: number;
  name: string;
  abbreviation: string;
  buy: number;
  sell: number;
  icon_link: string;
}
function Rows() {
  const [data, setData] = useState<Currency[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api-panel.parsianbit.com/publish/v1/currency"
        );

        const currencies = response.data?.data?.currencies || [];

        setData(currencies);
        setLoading(false);
      } catch (err: any) {
        console.error("Error fetching data:", err);
        setError("خطا در دریافت داده‌ها");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading)
    return (
      <CircularProgress
        sx={{
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 4,
        }}
      />
    );
  if (error) return <p>{error}</p>;
  if (!Array.isArray(data) || data.length === 0)
    return <p>داده‌ای برای نمایش وجود ندارد.</p>;

  return (
    <>
      {data.map((currency, index) => (
        <Paper
          key={currency.id}
          className="live-prices data-row"
          sx={{ borderRadius: "10px", px: 2, py: 1, my: 1 }}
          elevation={0}
        >
          <Grid container columns={18} justifyContent={"space-between"}>
            <Grid sx={{ alignSelf: "center" }} item xs={1}>
              {index + 1}
            </Grid>
            <Grid sx={{ alignSelf: "center" }} item xs={4} sm={4} mr={2}>
              <Box display="flex" alignItems="center">
                <img
                  src={currency.icon_link}
                  alt={currency.abbreviation}
                  width={32}
                  height={32}
                  style={{ marginLeft: "12px" }}
                />
                {currency.name}
              </Box>
            </Grid>

            <Grid sx={{ alignSelf: "center" }} item lg={4} xs={3} sm={4}>
              {new Intl.NumberFormat().format(currency.buy)} تومان
            </Grid>

            <Grid sx={{ alignSelf: "center" }} item lg={4} xs={5} sm={4} ml={2}>
              {new Intl.NumberFormat().format(currency.sell)} تومان
            </Grid>
            <Grid
              sx={{ alignSelf: "center" }}
              item
              lg={4}
              xs={5}
              sm={4}
              display={{ xs: "none", md: "block" }}
            >
              <Link to="https://panel.parsianbit.com/trade">
                <Button sx={{ bgcolor: "#FF3DFF", color: "#fff" }}>
                  خرید / فروش
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  );
}

export function LivePricesTable(props: LivePricesTableProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Grid container maxWidth="lg" sx={{ mx: "auto" }} rowSpacing={2}>
        {!!props.label && (
          <Grid item xs={12}>
            <Typography textAlign="center" variant="h5">
              {props.label}
            </Typography>
          </Grid>
        )}
        <Grid item container xs={12} spacing={2}></Grid>
        <Grid item xs={12}>
          <Paper
            className="live-prices data-row"
            sx={{ borderRadius: "10px", px: 2, py: 1 }}
            elevation={0}
          >
            <Grid container columns={18} justifyContent={"space-between"}>
              <Grid item xs={1}>
                #
              </Grid>
              <Grid item xs={4} sm={5}>
                {t("name")}
              </Grid>

              <Grid item lg={4} xs={5} sm={3.5}>
                {t("buy")}
              </Grid>
              <Grid item lg={4} xs={5} sm={3.5}>
                {t("sell")}
              </Grid>
              <Grid item xs={4} display={{ xs: "none", md: "block" }}>
                معامله
              </Grid>
            </Grid>
          </Paper>
          <Rows />
        </Grid>
        {!!props.more && (
          <Grid item xs={12}>
            <Typography textAlign="center" variant="body1" fontWeight={"bold"}>
              <Button
                href={props.more}
                sx={{ color: "#1E88E5", fontWeight: "bold", border: "none" }}
                variant="text"
                endIcon={<ArrowBackIosIcon />}
              >
                {t("view_more")}
              </Button>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
